import React from 'react'
import config from '../config.json'
import Translation from './Translation'
import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import { useEffect } from 'react';

const AttributeTooltip = ({attributeId, translation, onClick, mouseOver, isMobile}) => {
    const [tooltipId, setTooltipId] = useState(null)
    if(!attributeId) {
        return ''
    }        

    useEffect(() => {
        if(!tooltipId) {
            //needed for constant id
            setTooltipId(uuidv4())
        }
    })

    const tooltipConfig = config.tooltippedAttributes
    const tooltippedAttribute = tooltipConfig[attributeId]
    const {name, description} = tooltippedAttribute

    if(mouseOver) {
        var tooltipWrapper = document.getElementById(tooltipId);

        if(!isMobile) {
            window.onmousemove = function (e) {
                var x = e.clientX,
                    y = e.clientY;
                tooltipWrapper.style.top = (y + 20) + 'px';
                tooltipWrapper.style.left = (x + 20) + 'px';
            };
        }
    }

    const displayStyle = mouseOver ? 'block' : 'none'

    const style = {
        display: displayStyle
    }

    return <div style={style} id={tooltipId} className='tooltip-wrapper theme-radius-posters-full' onClick={onClick}>
        <h5><Translation id={name} trans={translation}>Tooltip Headline</Translation></h5>
        <p className='attribute-text'><Translation id={description} trans={translation}>Tooltip Description</Translation></p>
    </div>
}

export default AttributeTooltip